const SAMPLE_TYPE_WATER = 'WaterSample';
const SAMPLE_TYPE_GLYCOL = 'GlycolSample';
const SAMPLE_TYPE_LEGIONELLOSIS = 'LegionellosisSample';
const SAMPLE_TYPE_LEGIONELLA_CULTURE = 'LegionellaCultureSample';
const SAMPLE_TYPE_DEPOSIT = 'DepositSample';
const SAMPLE_TYPE_COUPON = 'CouponSample';
const SAMPLE_TYPE_CONTENANCE = 'ContenanceSample';
const SAMPLE_TYPE_RESIN = 'ResinSample';
const SAMPLE_TYPE_OTHER = 'OtherSample';

const GLYCOL_TYPE_ETHYLENE = 'ethylene';
const GLYCOL_TYPE_PROPYLENE = 'propylene';
const GLYCOL_TYPE_UNKNOWN = 'unknown';
const GLYCOL_TYPE_OTHER = 'other';
const SAMPLE_TYPE_GLYCOL_TYPES = [GLYCOL_TYPE_ETHYLENE, GLYCOL_TYPE_PROPYLENE, GLYCOL_TYPE_UNKNOWN, GLYCOL_TYPE_OTHER];

const SAMPLE_TYPES = [
    SAMPLE_TYPE_WATER,
    SAMPLE_TYPE_GLYCOL,
    SAMPLE_TYPE_LEGIONELLOSIS,
    SAMPLE_TYPE_LEGIONELLA_CULTURE,
    SAMPLE_TYPE_DEPOSIT,
    SAMPLE_TYPE_CONTENANCE,
    SAMPLE_TYPE_RESIN,
    SAMPLE_TYPE_COUPON,
    SAMPLE_TYPE_OTHER,
];
module.exports = {
    SAMPLE_TYPES,
    SAMPLE_TYPE_WATER,
    SAMPLE_TYPE_GLYCOL,
    SAMPLE_TYPE_LEGIONELLOSIS,
    SAMPLE_TYPE_LEGIONELLA_CULTURE,
    SAMPLE_TYPE_DEPOSIT,
    SAMPLE_TYPE_CONTENANCE,
    SAMPLE_TYPE_RESIN,
    SAMPLE_TYPE_COUPON,
    SAMPLE_TYPE_OTHER,
    SAMPLE_TYPE_GLYCOL_TYPES,
    GLYCOL_TYPE_ETHYLENE,
    GLYCOL_TYPE_PROPYLENE,
    GLYCOL_TYPE_UNKNOWN,
    GLYCOL_TYPE_OTHER,
};
